import { useEffect, useState } from 'react';
import { LeaveRequestApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { addProfileUpcomingLeaveRequests } from '../../../store/slices/user-profile.slice';
import { Pageable } from '@cyberlabrs/types';

interface ILeaveRequestSearchParams extends Pageable {}
const SIZE = 20;
const DEFAULT_PAGE = 0;

const useHttpGetUpcomingLeaveRequestsByUserSubOnMount = (userSub: string, params?: ILeaveRequestSearchParams) => {
    const leaveRequestApi = useContainer(LeaveRequestApi);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = leaveRequestApi.getUpcomingLeaveRequestsForUserProfile({
        query: {
            size: params?.size ?? SIZE,
            page: params?.page ?? DEFAULT_PAGE,
            ...(params?.sort && { sort: params.sort }),
            ...(params?.direction && { direction: params.direction }),
        },
        params: { userSub },
        onSuccess: res => {
            dispatch(addProfileUpcomingLeaveRequests(res.body));
        },
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { isReady, exec };
};

export default useHttpGetUpcomingLeaveRequestsByUserSubOnMount;
